import { useGetMLStoresQuery } from 'api/ml-service/ml-service';
import AutocompleteField from 'components/forms/fields/autocomplete-field/autocomplete-field.component';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const MLStoresField = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetMLStoresQuery(null);

  const storeOptions = useMemo(
    () => [
      {
        label: t('forms.fields.stores.allOption'),
        id: 'ALL',
      },
      ...(data?.locations?.map(location => ({
        id: location.locationId,
        label: location.locationName,
      })) ?? []),
    ],
    [data?.locations, t],
  );

  return (
    <AutocompleteField
      name="locationIds"
      options={storeOptions}
      multiple
      data-testid="MLConfigurationForm.StoreField"
      limitTags={2}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      label={t('forms.fields.stores.label')}
      withSelectAllOption
      loading={isLoading}
    />
  );
};

export default MLStoresField;
